import React from 'react'
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, IconButton } from '@mui/material'
import { Close, Group } from '@mui/icons-material'
import { NavLink } from 'react-router-dom'
import { useSettingsSidebar } from '../../../contexts/SettingsSidebarContext'


const menuItems = [
    {
        text: 'Users & permissions',
        icon: <Group />,
        path: '/settings/users-permissions'
    }
]

export default function SettingsSidebar() {
    const { isOpen, toggleSidebar } = useSettingsSidebar()

    return (
        <Box
            sx={{
                width: isOpen ? 240 : 64,
                height: '100%',
                flexShrink: 0,
                transition: 'width 0.225s cubic-bezier(0.4, 0, 0.6, 1)',
                backgroundColor: '#ffffff',
                borderRight: '1px solid #e5e7eb',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    height: 64,
                    px: 1.5,
                }}
            >
                <IconButton
                    onClick={toggleSidebar}
                    sx={{
                        padding: '8px',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                    }}
                >
                    <Close fontSize="small" />
                </IconButton>
            </Box>
            <List sx={{ flexGrow: 1, p: 0, pt: 0.5 }}>
                {menuItems.map((item) => (
                    <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                        <NavLink
                            to={item.path}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            {({ isActive }) => (
                                <ListItemButton
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: isOpen ? 'initial' : 'center',
                                        px: 2,
                                        mx: 1,
                                        borderRadius: '6px',
                                        backgroundColor: isActive ? '#eff6ff' : 'transparent',
                                        color: isActive ? '#2563eb' : '#6b7280',
                                        '&:hover': {
                                            backgroundColor: isActive ? '#dbeafe' : '#f3f4f6',
                                        },
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: isOpen ? 2 : 'auto',
                                            justifyContent: 'center',
                                            color: 'inherit',
                                        }}
                                    >
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.text}
                                        slotProps={{
                                            primary: {
                                                fontSize: '14px',
                                                fontWeight: isActive ? 500 : 400,
                                            }
                                        }}
                                        sx={{
                                            opacity: isOpen ? 1 : 0,
                                            whiteSpace: 'nowrap',
                                        }}
                                    />
                                </ListItemButton>
                            )}
                        </NavLink>
                    </ListItem>
                ))}
            </List>
        </Box>
    )
}
